/**
 * loader.js — Animated loading indicator (CSS + factory)
 */

/** Inject loader CSS once */
export function ensureLoaderStyles() {
	if (document.getElementById("mt-loader-css")) return;
	const css = `
.mt-loader{display:inline-flex;align-items:center;gap:.4rem;font:500 14px/1.4 system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;color:#334;background:#e5f5fb;padding:.5rem .65rem;box-shadow:0 0 0 1px rgba(0,0,0,.06) inset;margin-bottom:12px;}
.mt-loader .dots{display:inline-block;width:1.2em;text-align:left}
.mt-loader .dot{display:inline-block;width:.25em;height:.25em;margin:0 .05em;border-radius:50%;background:#009cd6;opacity:.3;animation:mt-bounce 1.2s infinite}
.mt-loader .dot:nth-child(2){animation-delay:.15s}
.mt-loader .dot:nth-child(3){animation-delay:.30s}
@keyframes mt-bounce{0%,80%,100%{transform:translateY(0);opacity:.3}40%{transform:translateY(-2px);opacity:1}}
`.trim();
	const s = document.createElement("style");
	s.id = "mt-loader-css";
	s.textContent = css;
	document.head.appendChild(s);
}

/**
 * Create a loader element and prepend it to `parent`.
 * Returns { el, remove() }.
 */
export function createLoader(parent, msg = "Loading") {
	ensureLoaderStyles();

	const wrap = document.createElement("div");
	wrap.className = "mt-loader";
	wrap.setAttribute("role", "status");
	wrap.setAttribute("aria-live", "polite");
	wrap.innerHTML = `
<span class="txt">${msg}</span>
<span class="dots"><span class="dot"></span><span class="dot"></span><span class="dot"></span></span>
`;
	if (parent) parent.prepend(wrap);
	return {
		el: wrap,
		remove() {
			wrap.remove();
		},
	};
}
